import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderKempResources extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices);
    this.minLabel = { en: 'min', de: 'minuten', nl: 'minuten', es: 'minutos', pt: 'minutos', fr: 'minutes', sv: 'minuter', jp: '分', 'zh-TW': '分', cs: 'min' };
    this.defaultResourceData = [
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/data-sheet-thumnail.svg",
        id: "eeb3c6b5-1f50-4737-a2f3-717e59683ec2"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/webinar-thumnail.svg",
        id: "d743233e-7255-424b-ad23-32b674f698db"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/research-papers-thumnail.svg",
        id: "331bb5f5-7884-4806-8a32-946ebe52bedb"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/case-studies-thumnail.svg",
        id: "6e38772a-82c5-454a-b6e6-740504dce161"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/video-thumnail.svg",
        id: "c5dbf402-5020-4c9f-a6e5-80fbc168e2e8"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/solution-brief-thumnail.svg",
        id: "42bf0060-28dd-4c4c-a1a5-c6b74232ec40"
      },
      {
        imagePath: "/images/kemptechnologieslibraries/resources/default-thumbnails/glossary-thumbnail.svg",
        id: "4e164743-8057-47fc-aedf-70893c4361e2"
      }
    ]
  }

  getResourceCtaLabel(contentType) {
    const lang = this.filterService.getSelectedLanguage();

    const learnMoreLabel = { en: 'Learn more', de: 'Erfahren Sie mehr', fr: 'Learn more', es: 'Learn more', ja: 'Learn more'};
    const watchTheVideoLabel = { en: 'Watch the video', de: 'Watch the video', fr: 'Watch the video', es: 'Watch the video', ja: 'Watch the video' };
    const registerLabel = { en: 'Register', de: 'Register', fr: 'Register', es: 'Register', ja: 'Register' };
    const watchTheWebinarLabel = { en: 'Watch the webinar', de: 'Watch the webinar', fr: 'Watch the webinar', es: 'Watch the webinar', ja: 'Watch the webinar' };
    const downloadLabel = { en: 'Download', de: 'Download', fr: 'Download', es: 'Download', ja: 'Download' };
    const viewPdfLAbel = { en: 'View PDF', de: 'View PDF', fr: 'View PDF', es: 'View PDF', ja: 'View PDF' };
    const seeMoreLAbel = { en: 'See More', de: 'Erfahren Sie mehr', fr: 'See More', es: 'See More', ja: 'See More' };

    switch (contentType.Id) {
      case '95d3ec8e-65be-4005-bbbf-cf94764bec84': // Live webinar
        return registerLabel[lang];
      case 'ba3505a5-edf2-4b48-8196-3cd4ec03e8b3': // On-demand webinar
        return watchTheWebinarLabel[lang];
      case 'c5dbf402-5020-4c9f-a6e5-80fbc168e2e8': // Video
        return watchTheVideoLabel[lang];
      case 'fd8805fa-9232-4470-892e-e2e2bb263842': // Whitepaper
      case '63a9b7cc-0814-4876-8a8f-d77bd1451ddd': // Ebook
        return downloadLabel[lang];
      case 'd743233e-7255-424b-ad23-32b674f698db': // Webinar
      case '4e164743-8057-47fc-aedf-70893c4361e2': // Glossary
        return learnMoreLabel[lang];
      case '42bf0060-28dd-4c4c-a1a5-c6b74232ec40': // Solution brief
      case 'eeb3c6b5-1f50-4737-a2f3-717e59683ec2': // Data sheet
        return viewPdfLAbel[lang];
      case '331bb5f5-7884-4806-8a32-946ebe52bedb': // Research papers
      case '6e38772a-82c5-454a-b6e6-740504dce161': // Case study
        return seeMoreLAbel[lang];
      default:
        return this.CTAText;
    }
  }

  getItemHtml(item, relatedMedia) {
    const { imageData, fileData } = super.setRelatedMedia(item, relatedMedia);
    const { Title, CTAText, UrlName: resourcePath, Summary, ExternalUrl, CTAUrl } = item;
    const contentType = item.resourceCategory[0];
    let isWebinar = contentType.Id == "d743233e-7255-424b-ad23-32b674f698db" || contentType.Id == "95d3ec8e-65be-4005-bbbf-cf94764bec84"|| contentType.Id == "ba3505a5-edf2-4b48-8196-3cd4ec03e8b3";
    const pageUrl = super.getResourceUrl(item.contenttypes[0]);
    const featuredLabel = Boolean(Number(item.IsFeatured)) ? '<span class="Resource-featured-label Label -br0 -fs11 -mt1">Featured</span>' : '';
    const selectedLanguage = this.filterService.getSelectedLanguage();
    const imagePath = item.ListImage.length > 0 ? imageData.Url : this.defaultResourceData.find(ct => ct.id === item.resourceCategory[0].Id)?.imagePath;
    const imageFallback = 'https://d34smkdb128qfi.cloudfront.net/images/librariesprovider2/default-album/resources/resource-default-thumbnail.jpg';
    const imageAlt = imageData.AlternativeText || 'default thumbnail';
    const summary = Summary ? `<div class="Resource-summary -fs16 -lines-4">${this.encodeHtml(Summary)}</div>` : '';
    let resourceUrl = `${pageUrl}/${resourcePath}`;
    let upcomingOrOnDemandLabel = `<span class="Resource-featured-label -fs11 -br0 Label -wa -mb1 -mt1  ${item.IsUpcomming ? "-tint-lightyellow" : "-tint-lightblue"}">${item.IsUpcomming ? "UPCOMING" : "On Demand"}</span>`;

    let formattedDate = null;
    // Live Webinar Start Date
    if (isWebinar && item.StartDate !== null) {
      let startDate = item.StartDate;
      let options = { year: '2-digit', month: 'numeric', day: 'numeric' };
      let webinarDate = new Date(startDate);
      formattedDate = webinarDate.toLocaleDateString(selectedLanguage, options);
      upcomingOrOnDemandLabel = `<span class="Resource-featured-label -fs11 -br0 Label -wa -mb1 -mt1  ${item.IsUpcomming ? "-tint-lightyellow" : "-tint-lightblue"}">${item.IsUpcomming ? "UPCOMING ON "+ formattedDate : "On Demand"}</span>`;
    }

    // Video Play Icon
    if (contentType.Id === 'C5DBF402-5020-4C9F-A6E5-80FBC168E2E8') {
      resourceEmbed += ' -i-play-lite -i--overlay -fs70 -accent-white';
    }

    if (CTAUrl) {
      resourceUrl = CTAUrl;
    } else if (ExternalUrl) {
      resourceUrl = ExternalUrl;
    }

    const html = `
      <div class="col-4 -xl-half -l-half -m-half -s-full -mb3">
        <div class="Resource -full -tint-white -br5 -h-scale Elevated">
          <a href="${!fileData ? resourceUrl : fileData.Url}" ${!fileData ? '' : 'target="_blank"'} class="Embed Embed--4by3 -db">
          <div class="-ml1 -pa -z1">${featuredLabel} ${isWebinar ? upcomingOrOnDemandLabel : ''}</div>
              <div class="Section-bg Section-bg--center">
                <img src="${imagePath || imageFallback}" alt="${imageAlt}" class="-full -op-solid">
              </div>
              ${!item.VideoLength ? '' : `<div class="Resource-floatingLabel -tint-white -ttn">${item.VideoLength}${this.minLabel[selectedLanguage] || this.minLabel.en}</div>`}
          </a>
          <div class="-df -mt0 -p2 -pb3 -pt1 -full -pr">
            <div class="-fs0 -mb1"><div class="Resource-label -ff-title -fs16 -ttu -c-grey3 -lh125">${contentType.Title}</div></div>
            <h5>${this.encodeHtml(Title)}</h5>
            ${summary}
            <a href="${!fileData ? resourceUrl : fileData.Url}" ${!fileData ? '' : 'target="_blank"'} class="HoverBox -i-arrow -ps -fs16 -fw5 -mta">
              ${this.encodeHtml(CTAText || this.getResourceCtaLabel(contentType))}
            </a>
          </div>
        </div>
      </div>
    `;

    return html;
  }
}
